module.exports = __webpack_public_path__ + "img/27_5.510bc3fc.png";